export default function () {
  const widgetName = 'seoBlockFeature';
  const widgetOpts = seoBlockFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customWidget() {

          $(`#${widgetName} .card-widget-item`).each((function () {
          $(this).find(".card-content").wrap('<div class="seo-block-layout"></div>'),
            $(this).find(".buttonwrap").remove(),
            $(this).find(".image-container, .image-container img").attr({
              "data-aos": "fade-left",
              "data-aos-easing": "ease-in-out",
              "data-aos-duration": "800",
              "data-aos-delay": "200",
              "data-aos-once": "true",
              "data-aos-offset": "200"
            })
        }
        ))
      }

      customWidget()
    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });
}